@if (busy) {
  <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
}
@if (fileItemObject && fileItemObject.canEdit) {
  <div class="edit-mode mb-2 flex-row">
    <span class="text-bold text-lg w-100 text-center">EDIT MODE</span>
  </div>
}
@if(fileItemObject && fileItemObject.fileContent){
  <div class="flex-col justify-start items-stretch w-100">
    <div class="flex-row space-between items-center mb-3">
      <span class="mr-3">{{fileItemObject.fileNameWithExtension}}</span>
      <mat-button-toggle-group class="mb-3" name="logic" aria-label="Logic" class="mt-2">
        <mat-button-toggle (click)="onDownloadClick()" matTooltip="Download"><mat-icon class="text-muted">cloud_download</mat-icon></mat-button-toggle>
        @if (fileItemObject.canRestore) {
          <mat-button-toggle (click)="onRestoreClick()" matTooltip="Restore"><mat-icon class="text-muted">restore</mat-icon></mat-button-toggle>
        }
        @if (fileItemObject.canSave) {
          <mat-button-toggle (click)="onSaveClick()" matTooltip="Save"><mat-icon class="text-muted">save</mat-icon></mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
    @if (fileItemObject.outputFileType!='xml' && fileItemObject.outputFileType!='json' && fileItemObject.fileContent) {
      <div class="container" [innerText]='fileItemObject.fileContent' [contentEditable]="fileItemObject.canEdit" #fileOutput (keydown)="fileItemObject.contentUpdated()"></div>
    }
    @if (fileItemObject.outputFileType=='xml' && fileItemObject.fileContent) {
      <div class="container" [innerText]='fileItemObject.xmlFileContent' [contentEditable]="fileItemObject.canEdit" #fileOutput (keydown)="fileItemObject.contentUpdated()"></div>
    }
    @if (fileItemObject.outputFileType=='json' && fileItemObject.fileContent) {
      <pre class="container" [innerText]='fileItemObject.jsonFileContent | json' [contentEditable]="fileItemObject.canEdit" #fileOutput (keydown)="fileItemObject.contentUpdated()"></pre>
    }
    @if (fileItemObject.message) {
      <div>{{fileItemObject.message}}</div>
    }
    @if (fileItemObject.errors) {
      <div>
        @for (error of fileItemObject.errors; track $index; let i = $index) {
          <div>
            Error in column '{{error.columnName}}' row {{error.rowIndex}}: {{error.message}}
          </div>
        }
      </div>
    }
  </div>
}
